import serializeSearchParam from "~/routes/time-slots/serializeSearchParam";
import route from "./route";
import { z } from "zod";
import type { Booking, Company } from "@prisma/client";
import type { Animal } from "~/repositories/Animal";

const CUSTOMER_ROUTES = {
  customerHome: route(() => `/customer/home`),
  customerHomeBookings: route("/customer/home/bookings"),
  customerHomeAnimals: route("/customer/home/animals"),
  customerHomeSettings: route("/customer/home/settings"),
  customerDeleteAccount: route("/customer/account/delete"),
  bookingBatchUpsertAnimals: route(
    ({ slug }: Pick<Company, "slug">) =>
      `/companies/${slug}/bookings/animals/batch`,
  ),
  bookingConfirmation: route(
    (bookingId) => `/bookings/${bookingId}/confirmation`,
  ),
  bookingSummary: route("/booking-summary"),
  bookingUpdateUser: route(
    ({ slug }: Pick<Company, "slug">) => `/companies/${slug}/bookings/new/user`,
  ),
  cancelBooking: route(
    ({ id }: Pick<Booking, "id">) => `/bookings/${id}/cancel`,
  ),
  animalPickableServices: route(
    ({ animalId, companyId }: { companyId: string; animalId: string }) =>
      `/companies/${companyId}/animals/${animalId}/pickable-services`,
  ),
  customerBookings: route.fromTemplate("/customer/bookings", {
    query: z.object({ page: z.coerce.number().catch(1) }),
  }),
  customerEditAnimal: route(
    ({ id }: Pick<Animal, "id">) => `/customer/animals/${id}/edit`,
  ),
  customerNewAnimal: route("/customer/animals/new"),
  timeSlots: route(
    (
      state: Parameters<typeof serializeSearchParam>[0],
      scope: { startsAt: Date; endsAt: Date },
    ) => `/time-slots?search=${serializeSearchParam(state, scope)}`,
  ),
};

export default CUSTOMER_ROUTES;
